export default "__VITE_ASSET__d8YPqODe__"